import { DATA, BARSMARGINSIDE } from '../../Constants';
import { scaleLinear, scaleBand } from 'd3-scale';
import { getMargin } from '../../Utils';

interface Props {
  primaryColor: string;
  roundedCorner: 0 | 1 | 2;
  barWidth: 0 | 1 | 2;
  isXScaleTicksValueRotated: boolean;
  isYScaleTicksValueVisible: boolean;
  yScaleTicksValueAlignment: 'left' | 'right';
  yScaleTicksValuePosition: 'top' | 'center';
  isTicksTitleVisible: boolean;
  width: number;
  height: number;
}

export const Bars = (props: Props) => {
  const {
    primaryColor,
    roundedCorner,
    barWidth,
    isXScaleTicksValueRotated,
    isYScaleTicksValueVisible,
    yScaleTicksValueAlignment,
    yScaleTicksValuePosition,
    isTicksTitleVisible,
    width,
    height,
  } = props;
  const margin = getMargin(
    isYScaleTicksValueVisible,
    isTicksTitleVisible,
    yScaleTicksValuePosition,
    yScaleTicksValueAlignment,
    isXScaleTicksValueRotated,
  );
  const barsOffset =
    isYScaleTicksValueVisible && yScaleTicksValuePosition === 'top'
      ? BARSMARGINSIDE
      : 0;
  const graphHeight = height - margin.top - margin.bottom;
  const graphWidth = width - margin.left - margin.right - barsOffset;
  const paddingInner = barWidth === 0 ? 0.1 : barWidth === 1 ? 0.25 : 0.5;
  const yScale = scaleLinear().domain([0, 10000]).range([graphHeight, 0]);
  const xScale = scaleBand()
    .range([0, graphWidth])
    .domain(DATA.map(d => d.month))
    .paddingInner(paddingInner)
    .paddingOuter(isYScaleTicksValueVisible ? 0.2 : 0);
  return (
    <g
      transform={`translate(${
        yScaleTicksValueAlignment === 'left'
          ? margin.left + barsOffset
          : margin.left
      },${margin.top})`}
    >
      {DATA.map((d, i) => {
        return (
          <rect
            key={i}
            x={xScale(d.month)}
            y={yScale(d.value)}
            width={xScale.bandwidth()}
            height={graphHeight - yScale(d.value)}
            fill={primaryColor}
            rx={roundedCorner === 0 ? 0 : roundedCorner === 1 ? 5 : 10}
            ry={roundedCorner === 0 ? 0 : roundedCorner === 1 ? 5 : 10}
          />
        );
      })}
    </g>
  );
};
